import { accordian } from 'utility';

let accordianFunc = null;

window.responsive('mobile', () => {
  if (accordianFunc) accordianFunc.remove();
  accordianFunc = accordian('click');
});

window.responsive('tablet', () => {
  if (accordianFunc) accordianFunc.remove();
  accordianFunc = accordian('click');
});

window.responsive('desktop', () => {
  if (accordianFunc) accordianFunc.remove();
  accordianFunc = accordian('click');
});

window.responsive('ultrawide', () => {
  if (accordianFunc) accordianFunc.remove();
  accordianFunc = accordian('click');
});
